/*
Modified from:
https://github.com/brunomazzardo/moment-precise-range

The MIT License (MIT)

Copyright (c) 2014 Rob Dawson

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.
 */

import moment from "moment";

var STRINGS = {
    nodiff: '',
    year: 'year',
    years: 'years',
    month: 'month',
    months: 'months',
    day: 'day',
    days: 'days',
    hour: 'hour',
    hours: 'hours',
    minute: 'minute',
    minutes: 'minutes',
    second: 'second',
    seconds: 'seconds',
    delimiter: ' '
};

function pluralize(num, word) {
    return num + ' ' + STRINGS[word + (num === 1 ? '' : 's')];
}

function buildStringFromValues(yDiff, mDiff, dDiff, hourDiff, minDiff, secDiff) {
    var result = [];

    if (yDiff) {
        result.push(pluralize(yDiff, 'year'));
    }
    if (mDiff) {
        result.push(pluralize(mDiff, 'month'));
    }
    if (dDiff) {
        result.push(pluralize(dDiff, 'day'));
    }
    if (hourDiff) {
        result.push(pluralize(hourDiff, 'hour'));
    }
    if (minDiff) {
        result.push(pluralize(minDiff, 'minute'));
    }
    if (secDiff) {
        result.push(pluralize(secDiff, 'second'));
    }

    return result.join(STRINGS.delimiter);
}

function buildValueObject(yDiff, mDiff, dDiff, hourDiff, minDiff, secDiff, firstDateWasLater) {

    const result = {
        "years": yDiff,
        "months": mDiff,
        "days": dDiff,
        "hours": hourDiff,
        "minutes": minDiff,
        "seconds": secDiff,
        "firstDateWasLater": firstDateWasLater
    }
    return result
}


const preciseDiff = function (d1, d2, returnValueObject) {
    let m1 = moment(d1), m2 = moment(d2), firstDateWasLater;

    m1.add(m2.utcOffset() - m1.utcOffset(), 'minutes'); // shift timezone of m1 to m2

    if (m1.isSame(m2)) {
        if (returnValueObject) {
            return buildValueObject(0, 0, 0, 0, 0, 0, false);
        } else {
            return STRINGS.nodiff;
        }
    }
    if (m1.isAfter(m2)) {
        const tmp = m1;
        m1 = m2;
        m2 = tmp;
        firstDateWasLater = true;
    } else {
        firstDateWasLater = false;
    }

    let yDiff = m2.year() - m1.year();
    let mDiff = m2.month() - m1.month();
    let dDiff = m2.date() - m1.date();
    let hourDiff = m2.hour() - m1.hour();
    let minDiff = m2.minute() - m1.minute();
    let secDiff = m2.second() - m1.second();


    if (secDiff < 0) {
        secDiff = 60 + secDiff;
        minDiff--;
    }
    if (minDiff < 0) {
        minDiff = 60 + minDiff;
        hourDiff--;
    }
    if (hourDiff < 0) {
        hourDiff = 24 + hourDiff;
        dDiff--;
    }
    if (dDiff < 0) {
        var daysInLastFullMonth = moment(m2.year() + '-' + (m2.month() + 1), "YYYY-MM").subtract(1, 'M').daysInMonth();
        if (daysInLastFullMonth < m1.date()) { // 31/01 -> 2/03
            dDiff = daysInLastFullMonth + dDiff + (m1.date() - daysInLastFullMonth);
        } else {
            dDiff = daysInLastFullMonth + dDiff;
        }
        mDiff--;
    }
    if (mDiff < 0) {
        mDiff = 12 + mDiff;
        yDiff--;
    }

    if (returnValueObject) {
        return buildValueObject(yDiff, mDiff, dDiff, hourDiff, minDiff, secDiff, firstDateWasLater);
    } else {
        return buildStringFromValues(yDiff, mDiff, dDiff, hourDiff, minDiff, secDiff);
    }
};

function preciseFromNow(time) {
    return preciseDiff(moment(), moment(time));
}

export {preciseDiff, preciseFromNow}
